import { render, staticRenderFns } from "./UmsUserHistoryList.vue?vue&type=template&id=f40f6b66&"
import script from "./UmsUserHistoryList.vue?vue&type=script&lang=js&"
export * from "./UmsUserHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports